module.exports = __webpack_public_path__ + "img/accessory_item_12.b314f3b7.svg";